// api.js
import axiosInstance from "../../api/axiosInstance";

export const CompleteHotel = async (request) => {
    try {
        const response = await axiosInstance.put(
            `/api/v1/hotels/${request.hotelId}/guest-requests/${request.guestRequestId}/status`,
            {
                status: "Completed_Hotel",
                remarks: "",
            },
        );

        return response.data; // Return the response data on success
    } catch (error) {
        // Handle error, rethrow it to the calling component
        throw error.response ? error.response.data : error.message;
    }
};
